import { useLocationWeatherContext } from "../contexts/LocationWeatherContext";
import { getNextDateOnlyString, } from "../helpers/weather-helpers";
import { DAY_NIGHT_TEXT_COLOR } from "../types/Weather";
import TomorrowWeatherMainSection from "./TomorrowWeatherMainSection";
import WeatherCurrentDetailsSection from "./WeatherCurrentDetailsSection";
import WeatherPrecipatationSection from "./WeatherPrecipatationSection";
import { Box, Paper } from "@mui/material";


const TomorrowWeather = () => {

  const { currentWeather, hourlyWeatherUnit, hourlyWeatherMap, dailyWeatherMap, dailyWeatherUnit, isLoading } = useLocationWeatherContext();

  const tomorrowDateStr = getNextDateOnlyString(currentWeather?.time)
  if (!tomorrowDateStr) {
    return <></>;
  }

  const tomorrowHourlyWeather = hourlyWeatherMap.get(tomorrowDateStr);
  const tomorrowDailyWeather = dailyWeatherMap.get(tomorrowDateStr);
  if (!tomorrowHourlyWeather || !tomorrowDailyWeather || !hourlyWeatherUnit || !dailyWeatherUnit) {
    return <></>;
  }

  return (
    <Box >
      <TomorrowWeatherMainSection
        tomorrowHourlyWeather={tomorrowHourlyWeather}
        tomorrowDailyWeather={tomorrowDailyWeather}
        dailyWeatherUnit={dailyWeatherUnit} />
      <Paper sx={{
        borderRadius: '16px',
        marginTop: 2,
        paddingY: 0.005,
        paddingX: 2,
        backgroundColor: DAY_NIGHT_TEXT_COLOR,
        opacity: 0.85,
      }}>
        <WeatherCurrentDetailsSection
          dailyWeather={tomorrowDailyWeather}
          dailyWeatherUnit={dailyWeatherUnit}
          hourlyWeather={tomorrowHourlyWeather}
          hourlyWeatherUnit={hourlyWeatherUnit}
          headerText="Details" />
      </Paper>
      <Paper sx={{
        borderRadius: '16px',
        marginTop: 2,
        paddingY: 0.005,
        paddingX: 2,
        backgroundColor: DAY_NIGHT_TEXT_COLOR,
        opacity: 0.85,
      }}>
        <WeatherPrecipatationSection
          hourlyWeather={tomorrowHourlyWeather}
          hourlyWeatherUnit={hourlyWeatherUnit} />
      </Paper>
    </Box>
  );
}

export default TomorrowWeather;